export default {
  'menu.welcome': 'Welcome',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Admin Page',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.register-result': 'Register Result',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(fill transfer information)',
  'menu.form.step-form.confirm': 'Step Form(verify transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
  'menu.基本信息': 'Basic Info',
  'menu.基本信息.服务片区': 'Service Area',
  'menu.基本信息.新建片区': 'New Area',
  'menu.基本信息.编辑片区': 'Edit Area',
  'menu.基本信息.商户信息': 'Merchant Info',
  'menu.基本信息.商户搜索': 'Merchant Search',
  'menu.基本信息.新建商户': 'New Merchant',
  'menu.基本信息.编辑商户': 'Edit Merchant',
  'menu.基本信息.查看商户': 'View Merchant',
  'menu.基本信息.新增签订合同': 'New Contract',
  'menu.基本信息.编辑合同': 'Edit Contract',
  'menu.基本信息.查看合同': 'View Contract',
  'menu.基本信息.新建人员': 'New Personnel',
  'menu.基本信息.编辑人员': 'Edit Personnel',
  'menu.基本信息.运营信息': 'Operation Info',
  'menu.服务片区': 'Service Area',
  'menu.新建片区': 'New Area',
  'menu.商户信息': 'Merchant Info',
  'menu.商户搜索': 'Merchant Search',
  'menu.新建商户': 'New Merchant',
  'menu.编辑商户': 'Edit Merchant',
  'menu.查看商户': 'View Merchant',
  'menu.新增签订合同': 'New Contract',
  'menu.编辑合同': 'Edit Contract',
  'menu.查看合同': 'View Contract',
  'menu.新建人员': 'New Personnel',
  'menu.编辑人员': 'Edit Personnel',
  'menu.运营信息': 'Operation Info',
  'menu.新建清运记录': 'New Clearance Record',
  'menu.编辑清运记录': 'Edit Clearance Record',
  'menu.清运记录': 'Clearance Record',
  'menu.清运记录.清运记录': 'Clearance Record',
  'menu.清运记录.新建清运记录': 'New Clearance Record',
  'menu.清运记录.编辑清运记录': 'Edit Clearance Record',
  'menu.清运记录.清运排查': 'Clearance Investigation',
  'menu.到期提醒': 'Expiration Reminder',
  'menu.对账': 'Reconciliation',
  'menu.对账.对账列表': 'Reconciliation List',
  'menu.对账.手动对账': 'Manual Reconciliation',
  'menu.对账.查看': 'View',
  'menu.对账.新建手动对账': 'New Manual Reconciliation',
  'menu.对账.去对账': 'Go to Reconcile',
  'menu.对账列表': 'Reconciliation List',
  'menu.手动对账': 'Manual Reconciliation',
  'menu.开票': 'Invoice',
  'menu.开票.开票列表': 'Invoice List',
  'menu.开票.手动开票': 'Manual Invoice',
  'menu.开票.申请开票': 'Request Invoice',
  'menu.开票.查看开票': 'View Invoice',
  'menu.开票.发起手动开票': 'Initiate Manual Invoice',
  'menu.开票.商户开票': 'Merchant Invoice',
  'menu.开票列表': 'Invoice List',
  'menu.手动开票': 'Manual Invoice',
  'menu.回款': 'Payment',
  'menu.回款.回款列表': 'Payment List',
  'menu.回款.手动回款': 'Manual Payment',
  'menu.回款.完成回款': 'Complete Payment',
  'menu.回款.查看': 'View',
  'menu.回款.新建手动回款记录': 'New Manual Payment Record',
  'menu.回款列表': 'Payment List',
  'menu.手动回款': 'Manual Payment',
  'menu.现结回款': 'Cash Payment',
  'menu.充值': 'Recharge',
  'menu.充值.充值': 'Recharge',
  'menu.充值.查看': 'View',
  'menu.卡余额提醒': 'Card Balance Reminder',
  'menu.消纳': 'Disposal',
  'menu.消纳.消纳': 'Disposal',
  'menu.消纳.新建消纳': 'New Disposal',
  'menu.消纳.编辑': 'Edit',
  'menu.消纳.查看': 'View',
  'menu.统计分析': 'Statistical Analysis',
  'menu.规则设置': 'Rule Settings',
  'menu.系统设置': 'System Settings',
  'menu.系统设置.成员管理': 'Member Management',
  'menu.系统设置.成员列表': 'Member List',
  'menu.系统设置.添加成员': 'Add Member',
  'menu.系统设置.编辑成员': 'Edit Member',
  'menu.系统设置.查看成员': 'View Member',
  'menu.系统设置.角色与权限': 'Role & Permissions',
  'menu.系统设置.角色列表': 'Role List',
  'menu.系统设置.添加角色': 'Add Role',
  'menu.系统设置.编辑角色': 'Edit Role',
  'menu.系统设置.查看角色': 'View Role',
  'menu.系统设置.成员管理.添加成员': 'Add Member',
  'menu.系统设置.成员管理.编辑成员': 'Edit Member',
  'menu.系统设置.成员管理.查看成员': 'View Member',
  'menu.系统设置.角色与权限.添加角色': 'Add Role',
  'menu.系统设置.角色与权限.编辑角色': 'Edit Role',
  'menu.系统设置.角色与权限.查看角色': 'View Role',
  'menu.成员管理': 'Member Management',
  'menu.成员列表': 'Member List',
  'menu.添加成员': 'Add Member',
  'menu.编辑成员': 'Edit Member',
  'menu.查看成员': 'View Member',
  'menu.角色与权限': 'Role & Permissions',
  'menu.角色列表': 'Role List',
  'menu.添加角色': 'Add Role',
  'menu.编辑角色': 'Edit Role',
  'menu.查看角色': 'View Role',
  'menu.订单管理': 'Order Management',
  'menu.订单管理.订单管理': 'Order Management',
  'menu.订单管理.编辑': 'Edit',
  'menu.订单管理.查看': 'View',
  'menu.消纳管理': 'Disposal Management',
  'menu.消纳管理.消纳场': 'Disposal Site',
  'menu.消纳管理.新建消纳场': 'New Disposal Site',
  'menu.消纳管理.编辑消纳场': 'Edit Disposal Site',
  'menu.消纳管理.消纳单位': 'Disposal Unit',
  'menu.消纳管理.新建消纳单位': 'New Disposal Unit',
  'menu.消纳管理.编辑消纳单位': 'Edit Disposal Unit',
  'menu.消纳管理.查看消纳单位': 'View Disposal Unit',
  'menu.消纳管理.消纳充值': 'Disposal Recharge',
  'menu.消纳管理.新建消纳充值': 'New Disposal Recharge',
  'menu.消纳管理.查看消纳充值': 'View Disposal Recharge',
  'menu.消纳管理.消纳记录': 'Disposal Record',
  'menu.消纳管理.新建消纳': 'New Disposal',
  'menu.消纳管理.新建消纳记录': 'New Disposal Record',
  'menu.消纳管理.编辑消纳记录': 'Edit Disposal Record',
  'menu.消纳管理.查看消纳记录': 'View Disposal Record',
  'menu.消纳管理.编辑': 'Edit',
  'menu.消纳管理.查看': 'View',
  'menu.基本信息.桶 RFID 信息': 'Bucket RFID Info',
  'menu.基本信息.新建桶 RFID': 'New Bucket RFID',
  'menu.基本信息.编辑桶 RFID': 'Edit Bucket RFID',
  'menu.称重记录': 'Weight Record',
  'menu.称重记录.桶标签称重记录': 'Tag Weight Record',
  'menu.称重记录.无标签称重记录': 'Non-tag Weight Record',
  'menu.清运记录.记录称重对照表': 'Record Weight Comparison',
  'menu.数据上报': 'Data Reporting',
  'menu.数据上报.待上报数据': 'Pending Report Data',
  'menu.数据上报.一键补录': 'One-click Supplemental',
  'menu.数据上报.编辑数据': 'Edit Data',
  'menu.数据上报.编辑上报数据': 'Edit Report Data',
  'menu.数据上报.上报配置': 'Report Config',
  'menu.数据上报.历史记录': 'History Record',
  'menu.数据上报.数据明细': 'Data Details',
  'menu.数据获取': 'Data Acquisition',
  'menu.数据获取.上报主体获取': 'Subject Acquisition',
  'menu.数据获取.上报车辆获取': 'Vehicle Acquisition',
  'menu.数据获取.上报垃圾类型获取': 'Waste Type Acquisition', 
  'menu.基本信息.主体信息': 'Entity Info',
  'menu.基本信息.桶标 RFID 信息': 'Bucket RFID Info',
 
  'menu.数据获取.查看历史记录明细': 'View History Details',
 
  'menu.基本信息.新建主体': 'New Entity',
  'menu.基本信息.编辑主体': 'Edit Entity',
  'menu.基本信息.新建桶标 RFID 信息': 'New Bucket RFID',
  'menu.基本信息.编辑桶标 RFID 信息': 'Edit Bucket RFID',
  'menu.业务分类.非居民管理.编辑合同': 'Edit Contract',
  'menu.业务分类.非居民管理.商户管理.查看合同': 'View Contract',
  'menu.业务分类.非居民管理.商户管理.商户搜索': 'Merchant Search',
  'menu.业务分类.居民管理': 'Resident Management',
  'menu.业务分类.居民管理.主体信息': 'Entity Info',
  'menu.业务分类.居民管理.新建主体': 'New Entity',
  'menu.业务分类.居民管理.编辑主体': 'Edit Entity',
  'menu.业务分类.居民管理.桶标 RFID 信息': 'Bucket RFID Info',
  'menu.业务分类.居民管理.新建桶标 RFID 信息': 'New Bucket RFID',
  'menu.业务分类.居民管理.编辑桶标 RFID 信息': 'Edit Bucket RFID',
  'menu.业务分类.非居民管理.服务片区': 'Service Area',
  'menu.业务分类.非居民管理.新建服务片区': 'New Service Area',
  'menu.业务分类.非居民管理.编辑服务片区': 'Edit Service Area',
  'menu.业务分类.非居民管理.桶 RFID 信息': 'Bucket RFID Info',
  'menu.业务分类.非居民管理.新建桶 RFID': 'New Bucket RFID',
  'menu.业务分类.非居民管理.编辑桶 RFID': 'Edit Bucket RFID',
  'menu.业务分类.非居民管理.商户管理': 'Merchant Management',
  'menu.业务分类.非居民管理.商户管理.商户信息': 'Merchant Info',
  'menu.业务分类.非居民管理.商户管理.新建商户': 'New Merchant',
  'menu.业务分类.非居民管理.商户管理.编辑商户': 'Edit Merchant',
  'menu.业务分类.非居民管理.商户管理.查看商户': 'View Merchant', 
  'menu.业务分类.非居民管理.商户管理.新增签订合同': 'New Contract',
  'menu.业务分类.非居民管理.商户管理.编辑合同': 'Edit Contract', 
  'menu.车辆管理': 'Vehicle Management',
  'menu.车辆管理.一车一档': 'Vehicle Profile',
  'menu.车辆管理.新建车辆': 'New Vehicle',
  'menu.车辆管理.编辑车辆': 'Edit Vehicle',
  'menu.车辆管理.查看车辆详情': 'View Vehicle Details',
  'menu.车辆管理.运营记录': 'Operation Record',
  'menu.车辆管理.车辆过户': 'Vehicle Transfer',
  'menu.人员管理': 'Personnel Management',
  'menu.人员管理.司机管理': 'Driver Management',
  'menu.运营单位管理': 'Operation Unit Management',
  'menu.新建运营单位管理': 'New Operation Unit',
  'menu.编辑运营单位管理': 'Edit Operation Unit',
  'menu.业务分类': 'Business Category',
  'menu.业务分类.非居民管理': 'Non-resident Management',
  'menu.智能问数': 'Smart Assistant',
  'menu.车辆作业': 'Vehicle Operations',
  'menu.车辆作业.每日出车计划': 'Daily Dispatch Plan',
  'menu.车辆作业.作业配置': 'Job Configuration',
  'menu.车辆作业.商户通知设置': 'Merchant Notification Settings',
};
